enum PaymentTransactionFileTypeEnum {
  OTHER = 1, // noter evrağı, devir evrağı vs.
  CONSENT = 2, // muvafakatname
}

export default PaymentTransactionFileTypeEnum;
